import type { Translation } from "../types";

const ja: Translation = {
    // Navigation
    "nav.home": "ホーム",
    "nav.tools": "ツール",
    "nav.minddeck": "MindDeck",
    "nav.jsonparser": "JSON Parser",
    "nav.guide": "ガイド",
    "nav.about": "概要",
    "nav.contact": "お問い合わせ",
    "nav.faq": "FAQ",
    "nav.privacy": "プライバシー",
    "nav.terms": "利用規約",
    "nav.changelog": "変更履歴",
    "nav.roadmap": "ロードマップ",

    // Common
    "common.loading": "読み込み中...",
    "common.error": "エラーが発生しました",
    "common.back": "戻る",
    "common.next": "次へ",
    "common.previous": "前へ",
    "common.search": "検索",
    "common.menu": "メニュー",
    "common.close": "閉じる",
    "common.learnMore": "詳細を見る",

    // Home
    "home.title": "開発者と学習者のためのツール",
    "home.subtitle":
        "効率的で直感的なWebベースツールで生産性を向上させましょう",
    "home.tools.title": "提供ツール",
    "home.minddeck.title": "MindDeck",
    "home.minddeck.desc": "スマートなフラッシュカード学習ツール",
    "home.jsonparser.title": "JSON Diff Parser",
    "home.jsonparser.desc": "JSON構造比較・分析ツール",
    "home.features.title": "主な特徴",
    "home.features.performance.title": "高速パフォーマンス",
    "home.features.performance.desc":
        "最適化されたWeb技術による高速で効率的な処理",
    "home.features.security.title": "安全な使用",
    "home.features.security.desc":
        "クライアントサイド処理によるデータセキュリティの確保",
    "home.features.multilingual.title": "多言語サポート",
    "home.features.multilingual.desc": "韓国語、英語、日本語、中国語をサポート",
    "home.cta.title": "今すぐ始めましょう",
    "home.cta.subtitle": "無料で提供されるすべてのツールを活用してください",
    "home.cta.minddeck": "MindDeckを始める",
    "home.cta.jsonparser": "JSON Parserを使用",
    "home.learnMore": "詳細を見る",

    // About
    "about.title": "MewSeedsについて",
    "about.subtitle":
        "開発者と学習者のための革新的なWebツールを作成するチームです",
    "about.stats.tools": "提供ツール",
    "about.stats.languages": "対応言語",
    "about.stats.users": "ユーザー",
    "about.stats.uptime": "稼働率",
    "about.mission.title": "私たちのミッション",
    "about.mission.description":
        "複雑な作業を簡素化し、開発者と学習者がより効率的に作業できるツールを提供します。ユーザーエクスペリエンスを最優先とし、継続的な革新を通じてより良いソリューションを作り上げます。",
    "about.values.title": "コアバリュー",
    "about.values.innovation.title": "革新",
    "about.values.innovation.desc":
        "最新技術を活用してユーザーに最高の体験を提供します。",
    "about.values.userFirst.title": "ユーザーファースト",
    "about.values.userFirst.desc":
        "ユーザーのニーズとフィードバックに基づいて製品を開発します。",
    "about.values.privacy.title": "プライバシー保護",
    "about.values.privacy.desc":
        "ユーザーのプライバシーを保護し、安全なサービスを提供します。",
    "about.values.openSource.title": "オープンソース",
    "about.values.openSource.desc":
        "透明性と協力を通じてより良いツールを作り上げます。",
    "about.techStack.title": "技術スタック",
    "about.contact.title": "お問い合わせ",
    "about.contact.description":
        "ご質問やご提案がございましたら、お気軽にお問い合わせください。",
    "about.contact.email": "メールを送る",
    "about.contact.github": "GitHub",

    // Footer
    "footer.copyright": "© 2025 MewSeeds. All rights reserved.",
    "footer.madeWith": "MewSeeds、より良い世界のために",
    "footer.links": "クイックリンク",
    "footer.tools": "ツール",
    "footer.support": "サポート",
    "footer.contact": "連絡先",
    "footer.goto.minddeck": "MindDeckへ",
    "footer.goto.jsonparser": "JSON Parserへ",

    // Guide
    "guide.title": "ユーザーガイド",
    "guide.subtitle":
        "MewSeedsのすべてのツールを効果的に活用するためのステップバイステップガイドです。",
    "guide.minddeck.title": "MindDeck使用ガイド",
    "guide.minddeck.desc":
        "フラッシュカード学習ツールMindDeckのすべての機能を段階的に学びましょう。",
    "guide.minddeck.step1": "アカウント作成とログイン",
    "guide.minddeck.step2": "新しいデッキを作成",
    "guide.minddeck.step3": "カードの追加と編集",
    "guide.minddeck.step4": "学習モードを開始",
    "guide.minddeck.step5": "進捗の追跡と統計の確認",
    "guide.jsonparser.title": "JSON Parserの使い方",
    "guide.jsonparser.desc":
        "JSONデータを効率的に処理・変換する方法を学びましょう。",
    "guide.jsonparser.step1": "JSONデータを入力",
    "guide.jsonparser.step2": "構文チェックとエラー確認",
    "guide.jsonparser.step3": "データフォーマットの変換",
    "guide.jsonparser.step4": "フィルタリングと並べ替え機能",
    "guide.jsonparser.step5": "結果をエクスポート",
    "guide.stepsTitle": "ステップバイステップガイド",
    "guide.tipsTitle": "効果的な学習のためのヒント",
    "guide.tipsDesc": "より良い学習体験のための有用なアドバイス",
    "guide.tip1.title": "定期的な学習",
    "guide.tip1.desc": "毎日少しずつでも継続的に学習することが最も効果的です。",
    "guide.tip2.title": "実践中心の学習",
    "guide.tip2.desc": "理論だけでなく、実際にツールを使ってみましょう。",
    "guide.tip3.title": "コミュニティ活用",
    "guide.tip3.desc": "他のユーザーと経験やヒントを共有しましょう。",
    "guide.tip4.title": "フィードバック収集",
    "guide.tip4.desc": "利用中に見つけた問題点や改善点をお知らせください。",
    "guide.ctaTitle": "今すぐ始めましょう",
    "guide.ctaDesc": "ガイドに従いながら実際にツールを使ってみましょう。",
    "guide.cta.minddeck": "MindDeckを始める",
    "guide.cta.jsonparser": "JSON Parserを始める",
    "guide.modalTitle": "動画ガイド制作中",
    "guide.modalDesc": "もう少しお待ちください！",

    // Tools
    "tools.subtitle": "開発と学習に役立つWebベースのツール集",
    "tools.minddeck.desc":
        "スマートな反復学習アルゴリズムによる効率的な暗記ツール",
    "tools.minddeck.feature1": "反復学習アルゴリズム",
    "tools.minddeck.feature2": "進捗トラッキング",
    "tools.minddeck.feature3": "ダークモード対応",
    "tools.minddeck.feature4": "モバイル最適化",
    "tools.jsonparser.desc": "JSONデータ構造を視覚的に比較・分析するツール",
    "tools.jsonparser.feature1": "リアルタイム比較",
    "tools.jsonparser.feature2": "差分の可視化",
    "tools.jsonparser.feature3": "エラー検証",
    "tools.jsonparser.feature4": "クライアントサイド処理",
    "tools.detail": "詳細を見る",
    "tools.useNow": "今すぐ使う",
    "tools.coming.title": "さらに多くのツールを準備中です",
    "tools.coming.desc":
        "AI翻訳機やデータ可視化ツールなど便利なツールを開発中です。",
    "tools.roadmap": "ロードマップを見る",

    // ToolMindDeck
    "minddeck.header.title": "MindDeck",
    "minddeck.header.desc1": "フラッシュカード型のスマート学習ツール",
    "minddeck.header.desc2": "効率的な暗記と反復学習を誰でも簡単に！",
    "minddeck.features.title": "主な機能",
    "minddeck.features.1.title": "フラッシュカードの作成・管理",
    "minddeck.features.1.desc": "カードの追加、編集、削除が簡単にできます。",
    "minddeck.features.2.title": "スマート反復学習",
    "minddeck.features.2.desc":
        "Spaced Repetitionアルゴリズムで効率的な暗記をサポートします。",
    "minddeck.features.3.title": "進捗トラッキングと統計",
    "minddeck.features.3.desc": "学習の進捗や達成度を視覚的に確認できます。",
    "minddeck.features.4.title": "多言語・ダークモード対応",
    "minddeck.features.4.desc": "いつでもどこでも様々な環境で学習できます。",
    "minddeck.steps.title": "使い方",
    "minddeck.steps.1":
        "フラッシュカード追加で新しいデッキを作成、または既存のデッキを読み込みます。",
    "minddeck.steps.2": "暗記したい内容をカードとしてデッキに追加します。",
    "minddeck.steps.3":
        "学習モードを開始し、フラッシュカードを繰り返し学習します。",
    "minddeck.steps.4":
        "進捗や統計を確認しながら学習を続けましょう。デッキ内でカードの追加・削除・編集が可能です。",
    "minddeck.usecases.title": "活用例",
    "minddeck.usecases.1": "英単語、漢字、歴史の年号などの暗記科目学習",
    "minddeck.usecases.2": "プログラミング文法、用語、アルゴリズムの暗記",
    "minddeck.usecases.3": "資格試験対策、面接対策",
    "minddeck.usecases.4":
        "業務マニュアル、製品情報など反復学習が必要な分野全般",
    "minddeck.faq.title": "よくある質問（FAQ）",
    "minddeck.faq.1.q": "モバイルでも使えますか？",
    "minddeck.faq.1.a":
        "はい、MindDeckはモバイルとデスクトップの両方に最適化されています。モバイルChromeで右上の三点メニューから「ホーム画面に追加」-「アプリをインストール」を選ぶと、Webサイトをアプリのように使えます。",
    "minddeck.faq.2.q": "学習データは安全に保存されますか？",
    "minddeck.faq.2.a":
        "MindDeckは学習データを一切保存しません。すべてのデータはユーザーのブラウザにのみ保存されます。",
    "minddeck.faq.3.q": "無料で使えますか？",
    "minddeck.faq.3.a": "はい、MindDeckは誰でも無料で利用できます。",
    "minddeck.cta": "MindDeckへ",

    // ToolJsonParser
    "json.header.title": "JSON Parser",
    "json.header.desc1": "JSONの整形・比較・ビューア機能を一つに！",
    "json.header.desc2": "複雑なJSONデータも簡単・迅速に分析できます。",
    "json.features.title": "主な機能",
    "json.features.1.title": "JSON整形",
    "json.features.1.desc": "複雑なJSONデータを見やすく整形します。",
    "json.features.2.title": "JSON比較",
    "json.features.2.desc": "2つのJSONデータの違いを一目で比較できます。",
    "json.features.3.title": "JSONビューア",
    "json.features.3.desc": "ツリー構造でJSONを簡単に探索・分析できます。",
    "json.steps.title": "使い方",
    "json.steps.1": "整形・比較・ビューアから使いたい機能を選択します。",
    "json.steps.2": "JSONデータを入力します。",
    "json.steps.3": "結果を確認し、必要に応じてコピーします。",
    "json.usecases.title": "活用例",
    "json.usecases.1": "APIレスポンスデータの分析",
    "json.usecases.2": "バージョンごとのJSON構造比較",
    "json.usecases.3": "複雑なJSONツリーの可視化",
    "json.usecases.4": "データ変換・フォーマット化",
    "json.faq.title": "よくある質問（FAQ）",
    "json.faq.1.q": "大容量のJSONも処理できますか？",
    "json.faq.1.a":
        "はい、ほとんどの大容量JSONも高速に処理できます。ただし、ブラウザのメモリ制限により制約がある場合があります。",
    "json.faq.2.q": "JSON比較結果を保存できますか？",
    "json.faq.2.a":
        "はい、結果をコピーしたりファイルとしてダウンロードできます。",
    "json.faq.3.q": "モバイルでも使えますか？",
    "json.faq.3.a":
        "はい、モバイル環境でも最適化されています。モバイルChromeで右上の三点メニューから「ホーム画面に追加」-「アプリをインストール」を選ぶと、Webサイトをアプリのように使えます。",
    "json.cta": "JSON Parserへ",

    // Sidebar
    "sidebar.toolsOverview": "ツール紹介",
    "sidebar.companyInfo": "会社情報",

    // Privacy
    "privacy.title": "プライバシーポリシー",
    "privacy.lastUpdate": "最終更新: 2025年7月3日",

    // Terms
    "terms.title": "MewSeeds利用規約",
    "terms.lastUpdate": "最終更新: 2025年7月3日",
    "terms.section1.title": "第1条（目的）",
    "terms.section1.content":
        "本プライバシーポリシーは、MewSeedsおよびMewSeedsが提供するすべてのサブサービス（以下「サービス」）を運営する運営者（以下「運営者」）が、サービス提供に関連して収集・利用する利用者の個人情報処理基準を定めることを目的とします。",
    "terms.section2.title": "第2条（サービス利用）",
    "terms.section2.content":
        "利用者はサービスを自由に利用できます。利用者はサービス利用時に関連法令と本規約を遵守しなければならず、他の利用者のサービス利用を妨害したり、サービスの正常な運営を妨害してはなりません。利用者は運営者の事前書面同意なしに、サービスで提供された資料、情報、コンテンツを商業的に利用したり、複製、配布、送信、公開、二次的著作物作成などをしてはなりません。利用者は運営者の名称（MewSeeds等）、ロゴ、商標などを詐称したり無断で使用してはなりません。",
    "terms.section3.title": "第3条（知的財産権）",
    "terms.section3.content":
        "MewSeedsの名称、ロゴ、デザイン、プログラム、データベース、UI/UXなどサービスに関連する知的財産権は運営者にあります。利用者が本規約に違反して運営者の知的財産権を侵害した場合、運営者は民事および刑事上の法的措置を取ることができ、これにより発生した損害を請求できます。",
    "terms.section4.title": "第4条（広告）",
    "terms.section4.content":
        "運営者はサービス画面などに広告を掲載できます。利用者はサービス利用時に広告が表示される可能性があることを承認します。運営者はサービスの運営と無償提供のために広告を掲載し、これを通じて収益を創出できます。利用者が広告を通じて参加したり取引した結果発生した損害について運営者は責任を負いません。パーソナライズ広告提供に必要な情報収集・利用はプライバシーポリシーに従います。",
    "terms.section5.title": "第5条（免責事項）",
    "terms.section5.content":
        "運営者は天災地変、システム障害、サーバー過負荷、ハッキング、通信障害など不可抗力的事由によりサービスを提供できない場合、責任を負いません。運営者は利用者がサービスを通じて得た情報や資料の正確性、完全性、有用性について保証せず、これを信頼したり利用して発生した損害について責任を負いません。運営者は無償で提供されるサービスについて関連法令に特別な規定がない限り損害賠償責任を負いません。",
    "terms.section6.title": "第6条（紛争解決および管轄）",
    "terms.section6.content":
        "運営者と利用者はサービス利用に関連して紛争が発生した場合、誠実に協議して解決します。協議で解決されない場合、「コンテンツ産業振興法」、「電子商取引等における消費者保護に関する法律」などに基づく紛争調停機関に紛争調停を申請できます。紛争調停でも解決されない場合や調停を希望しない場合、訴訟は運営者の住所地を管轄する裁判所とします。",
    "terms.section7.title": "第7条（附則）",
    "terms.section7.content": "本規約は2025年7月3日から施行します。",
    "privacy.section1.title": "第1条（目的）",
    "privacy.section1.content":
        "本プライバシーポリシーは、MewSeedsおよびMewSeedsが提供するすべてのサブサービス（以下「サービス」）を運営する運営者（以下「運営者」）が、サービス提供に関連して収集・利用する利用者の個人情報処理基準を定めることを目的とします。",
    "privacy.section2.title": "第2条（収集する個人情報項目および方法）",
    "privacy.section2.content":
        "運営者は、サービス運営およびお問い合わせ対応等のために以下の個人情報を収集することができます。メールアドレス（お問い合わせ時収集）、ユーザーフィードバックに含まれる情報（名前、連絡先等利用者が自発的に入力した内容）。運営者は、サービス利用時に自動的に個人情報を収集せず、ただし、パーソナライズ広告提供等のためにクッキー等の識別情報が収集される場合があります。クッキー収集の可否は、利用者がブラウザ設定を通じて拒否することができます。",
    "privacy.section3.title": "第3条（個人情報の利用目的）",
    "privacy.section3.content":
        "運営者は、収集した個人情報を以下の目的でのみ利用します。利用者のお問い合わせへの回答および処理、法令上の義務遵守および紛争対応、パーソナライズ広告提供（同意した場合）",
    "privacy.section4.title": "第4条（個人情報保有および利用期間）",
    "privacy.section4.content":
        "収集された個人情報は、お問い合わせ処理完了後一定期間保管することができ、その後遅滞なく廃棄します。ただし、法令により一定期間保存しなければならない場合は、該当法令で定めた期間保管することができます。電子商取引法による取引記録：5年、通信秘密保護法によるアクセス記録：3ヶ月等",
    "privacy.section5.title": "第5条（個人情報第三者提供）",
    "privacy.section5.content":
        "運営者は、原則として利用者の個人情報を第三者に提供しません。ただし、以下の場合は例外的に提供される場合があります。利用者が事前に同意した場合、法令により提供が要求される場合",
    "privacy.section6.title": "第6条（個人情報保護責任者）",
    "privacy.section6.content": "名前: MewSeeds、メール: mewseeds@gmail.com",
    "privacy.section7.title": "第7条（権利および行使方法）",
    "privacy.section7.content":
        "利用者は、いつでも運営者に個人情報の閲覧、訂正、削除、処理停止等を要求することができ、運営者は法令に従って迅速に対応します。",
    "privacy.section8.title": "第8条（プライバシーポリシー変更）",
    "privacy.section8.content":
        "本方針は2025年7月3日から適用されます。運営者は本方針を変更する場合、変更事項を実施最少7日前、重要事項は30日前に通知します。",

    // Contact
    "contact.title": "お問い合わせ",
    "contact.subtitle":
        "ご質問やご提案がございましたら、いつでもお気軽にご連絡ください。",
    "contact.infoTitle": "連絡先情報",
    "contact.emailTitle": "メールアドレス",
    "contact.emailDesc": "一般的なお問い合わせやご提案",
    "contact.siteTitle": "ウェブサイト",
    "contact.siteDesc": "メインウェブサイト",
    "contact.timeTitle": "返信時間",
    "contact.timeValue": "24時間以内",
    "contact.timeDesc": "平日基準の迅速な返信",
    "contact.faqTitle": "よくある質問",
    "contact.faq1.q": "サービスは無料ですか？",
    "contact.faq1.a": "はい、すべてのツールは無料で提供されています。",
    "contact.faq2.q": "機能の提案はどうすればいいですか？",
    "contact.faq2.a":
        "メールでご提案をお送りいただければ、検討の上、反映いたします。",
    "contact.faq3.q": "バグ報告はどこでできますか？",
    "contact.faq3.a":
        "バグの内容を詳しくメールでご連絡いただければ、迅速に対応いたします。",
};

export default ja;
